import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
// import Minter from "./pages/Minter";
import Gallery from "./pages/Gallery";
import NFTDetail from "./pages/NFTDetail";
import Contact from "./pages/Contact";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/nft/:id" element={<NFTDetail />} />
        {/* <Route path="/minter" element={<Minter />} /> */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
